import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';
import { CreateAccount } from '@common/components/Icons';

export const Wrapper = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)};
`;

export const Content = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 1)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 1)};
`;

export const LinkCard = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  background-color: ${getThemeColor('grey.100')};
  color: inherit;
  ${({ theme }) => theme.getFluidSpacing('padding', 'scale', 3)};

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:focus-visible {
    text-decoration: underline;
  }
`;

export const LinkCardTitle = styled(Typography).attrs({
  customAs: 'h2',
  variant: 'h5',
})`
  margin-bottom: 0;
  line-height: 1;
  text-align: center;
`;

export const RegisterIcon = styled(CreateAccount)`
  fill: ${getThemeColor('bluegrey.70')};
  width: 61px;
  height: 61px;
  margin-bottom: 2rem;
`;
